import { createFormHook } from "@tanstack/react-form"
import { fieldContext, formContext } from "@/lib/form-context"
import { TextField } from "@/components/ui/text-field"
import { EmojiPickerField } from "@/components/ui/emoji-picker-field"
import { ColorPickerField } from "@/components/ui/color-picker-field"
import { SubmitButton } from "@/components/ui/submit-button"

export { useFieldContext, useFormContext } from "@/lib/form-context"

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    EmojiPickerField,
    ColorPickerField,
  },
  formComponents: {
    SubmitButton,
  },
})
